import { EMPTY_CELL, escapeHtml } from './escape-html';

/**
 * A text column where having no value is a normal answer, not missing data.
 *
 * TAKES `unknown` ON PURPOSE, like the other custom formatters. The API omits null
 * properties entirely, so a blacklist entry with no email address has no `email` key
 * and the CRUD hands this THE WHOLE ROW OBJECT instead of a string. Anything that is
 * not a string is therefore "nothing to show", which is correct for both real cases.
 *
 * Escaped because the value is typed by a person and painted through [innerHTML].
 */
export function optionalText(value: unknown): string {
    const text = typeof value === 'string' ? value.trim() : '';

    return text ? escapeHtml(text) : EMPTY_CELL;
}
